import { Card } from "@certn/cascadia-react";

import { ActivityLogTable } from "../ActivityLogTable";
interface Props {
  caseId: string | undefined;
}
export function ActivityLogTab({ caseId }: Props) {
  return (
    <Card testID="activity-log" type="large" responsive>
      <ActivityLogTable caseId={caseId || ""} />
    </Card>
  );
}
